import "./App.css";
import styles from "./App.styles";

import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import { Toaster } from "react-hot-toast";

import AdminPanel from "./pages/AdminPanel";
import Events from "./components/Events";
import Artists from "./components/Artists";
import ResponsiveAppBar from "./components/header";
import LandingPage from "./pages/LandingPage";
import { ContextProvider } from "./context";
import EventPage from "./pages/EventPage";
import ArtistPage from "./pages/ArtistPage";
import ResponsiveFooter from "./components/footer";
import ProtectedRoute from "./adminComponents/ProtectedRoute";
import { AppAuthProvider } from "./context/authContext";
import ContactPage from "./pages/ContactPage";
import AboutUsPage from "./pages/AboutUsPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const defaultTheme = createTheme();
const theme = createTheme({
  breakpoints: {
    values: {
      ...defaultTheme.breakpoints.values,
      md: 1000,
    },
  },
  palette: {
    primary: {
      main: "#2C2C2C",
    },
    secondary: {
      main: "#f50057",
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontFamily: "'Raleway', sans-serif" },
    h2: { fontFamily: "'Raleway', sans-serif" },
    h3: { fontFamily: "'Raleway', sans-serif" },
    h4: { fontFamily: "'Raleway', sans-serif" },
    h5: { fontFamily: "'Raleway', sans-serif" },
    h6: { fontFamily: "'Raleway', sans-serif" },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme} >
      <AppAuthProvider>
        <Toaster
          position="top-center"
          gutter={12}
          containerStyle={{ margin: "95px" }}
          toastOptions={{
            success: {
              duration: 3000,
              style: { color: "green" },
            },
            error: { duration: 5000 },
            style: {
              fontSize: "16px",
              maxWidth: "500px",
              padding: "16px 24px",
              backgroundColor: "white",
            },
          }}
        />
        <BrowserRouter>
          <Box sx={styles.appWrapperSx}>
            <ScrollToTop />
            <ContextProvider>
              <ResponsiveAppBar />
              <Box sx={styles.mainContentSx}>
                <Routes>
                  <Route path="/" Component={LandingPage} />
                  <Route path="/artists" Component={Artists} />
                  <Route path="/artist/:id" Component={ArtistPage} />

                  <Route path="/events" Component={Events} />
                  <Route path="/contact" Component={ContactPage} />
                  <Route path="/about" Component={AboutUsPage} />

                  <Route
                    path="/admin"
                    element={<ProtectedRoute element={<AdminPanel />} />}
                  />

                  <Route path="/event/:id" Component={EventPage} />
                </Routes>
              </Box>
            </ContextProvider>
            <ResponsiveFooter />
          </Box>
        </BrowserRouter>
      </AppAuthProvider>
    </ThemeProvider>
  );
}

export default App;
